namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class FormatMasterEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("Lot", "Lot No.");
            this.addOption("Account", "Account No.");
            this.addOption("Bag", "Bag No.");
            this.addOption("SKU", "SKU");
            this.addOption("Design", "Design No.");
            this.addOption("POSCustomer", "POS Customer"); 
            this.addOption("Employee", "Employee");
            this.addOption("FGLot", "Jewellery Lot No.");
            this.addOption("RefNo", "Ref No");
            this.addOption("ProductCode", "Product Code");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class SeparatorEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("", "");
            this.addOption("-","-");
            this.addOption("/", "/");
            this.addOption("_", "_");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class PrefixEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);
            this.addOption("[MM]/[YY]", "[MM]/[YY]");
            this.addOption("[MM]/[YYYY]", "[MM]/[YYYY]");
            this.addOption("[MON]/[YYYY]", "[MON]/[YYYY]");
            this.addOption("[MM][YY]", "[MM][YY]");
            this.addOption("[MM][YYYY]", "[MM][YYYY]");
            this.addOption("[YY]", "[YY]");
            this.addOption("[YYYY]", "[YYYY]");
        }
    }

    @Serenity.Decorators.registerEditor()
    export class SKUPrefixEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);
            this.addOption("ProductType", "ProductType");
            this.addOption("Category", "Category");
            this.addOption("SubCategory", "SubCategory");
            this.addOption("Brand", "Brand");
            this.addOption("Collection", "Collection");
            this.addOption("SuperType", "SuperType");
        }
    }
}